// frontend/src/hooks/useProject.js
import { useState, useEffect } from "react";
import { fetchProject, fetchLoanPartners } from "../utils/api";

export function useProject() {
  const [data, setData] = useState(null);
  const [loans, setLoans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);

    Promise.all([fetchProject(), fetchLoanPartners()])
      .then(([projectData, loanData]) => {
        setData(projectData);
        setLoans(loanData);
      })
      .catch((err) => {
        console.error("Project Fetch Error:", err);
        setError(err.message);
      })
      .finally(() => setLoading(false));
  }, []);

  return { data, loans, loading, error };
}